import Count from "./Count";
import React from "react";

export interface PaginationProps {
  page: number;
  carsCount: number;
  changePage: (values: number) => void;
}

export function Pagination(props: PaginationProps) {
  const { page, carsCount, changePage } = props;

  const LIMIT = Number(process.env.REACT_APP_LIMIT) || 10;
  const totalPages = Math.ceil(carsCount / LIMIT);

  // Function for generating visible pagination numbers
  const getVisiblePages = () => {
    const visiblePages = new Set<number>();

    // Always add first and last visible numbers
    visiblePages.add(1);
    visiblePages.add(totalPages);

    // Add 1 number and 1 adjecent
    for (
      let i = Math.max(page - 1, 1);
      i <= Math.min(page + 1, totalPages);
      i++
    ) {
      visiblePages.add(i);
    }

    return Array.from(visiblePages).sort((a, b) => a - b);
  };

  const visiblePages = getVisiblePages();

  return (
    <div className="flex items-center justify-between w-full gap-3 px-6 sm:px-0 sm:justify-start sm:w-auto">
      <svg
        onClick={page > 1 ? () => changePage(page - 1) : undefined}
        className="mr-auto cursor-pointer sm:mr-0"
        width="8"
        height="12"
        viewBox="0 0 8 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.57153 11.5714L1.30319 6.30306C1.13579 6.13569 1.13579 5.86434 1.30319 5.69697L6.57153 0.428584"
          stroke="#ABABAB"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      <div className="flex gap-0.5">
        {visiblePages.map((p, idx) => (
          <React.Fragment key={p}>
            {idx > 0 && p > visiblePages[idx - 1] + 1 && (
              <span className="text-sm leading-10 sm:leading-8 sm:text-black sm:text-opacity-100 text-gray-extra-dark text-opacity-80">
                ...
              </span>
            )}
            {p === page ? (
              <button onClick={() => changePage(p)}>
                <Count
                  count={p}
                  size="lg"
                  bgColor="bg-gray-light"
                  textColor="sm:text-black text-gray-extra-dark"
                ></Count>
              </button>
            ) : (
              <button onClick={() => changePage(p)}>
                <Count
                  count={p}
                  size="lg"
                  bgColor="bg-white"
                  textColor="sm:text-black text-gray-extra-dark text-opacity-80"
                ></Count>
              </button>
            )}
          </React.Fragment>
        ))}
      </div>

      <svg
        onClick={page < totalPages ? () => changePage(page + 1) : undefined}
        className="ml-auto cursor-pointer sm:ml-0"
        width="8"
        height="12"
        viewBox="0 0 8 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.42847 11.5714L6.69681 6.30306C6.86421 6.13569 6.86421 5.86434 6.69681 5.69697L1.42847 0.428584"
          stroke="#1D1D1B"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}

export default Pagination;
